
import { useState } from "react";
import { Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DocumentUploadDialog } from "./DocumentUploadDialog";
import { DocumentsList } from "./DocumentsList";
import { Requirement } from "@/types/project";

interface DocumentsDialogProps {
  requirement: Requirement;
  projectId: string;
  isOpen: boolean;
  onClose: () => void;
}

export function DocumentsDialog({ requirement, projectId, isOpen, onClose }: DocumentsDialogProps) {
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };
  
  return (
    <>
      <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
        <DialogContent className="sm:max-w-2xl">
          <DialogHeader>
            <DialogTitle>Documentation for {requirement.identifier || ""}</DialogTitle>
            <div className="flex justify-between items-center mt-4">
              <p className="text-sm text-muted-foreground">
                {requirement.requirement_text || requirement.text || ""}
              </p>
              <Button 
                size="sm" 
                onClick={() => setIsUploadDialogOpen(true)}
              >
                <Plus className="h-4 w-4 mr-2" />
                Upload Document
              </Button>
            </div>
          </DialogHeader>

          <div className="mt-4">
            <DocumentsList 
              requirement={requirement} 
              projectId={projectId} 
              onRefresh={handleRefresh}
              key={refreshTrigger}
            />
          </div>
        </DialogContent>
      </Dialog>

      {isUploadDialogOpen && (
        <DocumentUploadDialog
          requirement={requirement}
          projectId={projectId}
          isOpen={isUploadDialogOpen}
          onClose={() => setIsUploadDialogOpen(false)}
          onSuccess={handleRefresh}
        />
      )}
    </>
  );
}
